import {Skeleton, styled} from '@mui/material';

const StyledSkeleton = styled(Skeleton)`
	border-radius: 8px;
	height: 445px;
	width: 25%;

	${({theme}) => theme.breakpoints.down('sm')} {
		height: 366px;
		width: 50%;
	}

	${({theme}) => theme.breakpoints.between('sm', 'lg')} {
		width: 33%;
	}
`;

export {StyledSkeleton};
